import { render, staticRenderFns } from "./InstitutionCard.vue?vue&type=template&id=c7745b18&scoped=true&"
import script from "./InstitutionCard.vue?vue&type=script&lang=js&"
export * from "./InstitutionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7745b18",
  null
  
)

export default component.exports